import { Html5Entities } from 'html-entities';

export const decodeEntities = Html5Entities.decode;
